module.exports = __webpack_public_path__ + "static/Infographic4_3-Taoyuan_mobile-d03992719770b08a73e3285c6678c597.png";